import React, { useState } from "react";
import IncDecInput from "../../../components/IncDecInput";
import InputRemainders from "../../../components/InputRemainders";

const StakingCard = () => {
	const [stake, setStake] = useState("stake");
	return (
		<div className="stake-card">
			<div className="stake-card-menu">
				<div className="inner-div">
					<button
						type="button"
						className={stake === "stake" ? "active" : ""}
						onClick={() => setStake("stake")}
					>
						Stake
					</button>
					<button
						type="button"
						className={stake === "withdraw" ? "active" : ""}
						onClick={() => setStake("withdraw")}
					>
						Withdraw
					</button>
				</div>
			</div>
			{stake === "stake" ? <StakeCard /> : <WidthDrawCard />}
		</div>
	);
};
export const StakeCard = () => {
	const [duration, setDuration] = useState("30day");

	return (
		<>
			<div className="fadeIn">
				<div>
					<div className="__stake-count-badge-2">
						<span>Balance</span> <span>3000 ANT</span>
					</div>
					<div className="__stake-count-badge-2">
						<span>Stake balance:</span> <span>391 ANT</span>
					</div>
					<div className="__stake-count-badge-2">
						<span>Unlock Time</span> <span>Mar 21, 2022 15:38</span>
					</div>
				</div>
				<div className="stake-cart-area">
					<IncDecInput />
					<InputRemainders />
				</div>
				<div className="stake-duration">
					<h6 className="subtitle m-0">Duration:</h6>
					<div
						className="d-flex flex-wrap align-items-center"
						style={{ gap: "16px" }}
					>
						<span
							type="button"
							className={duration === "7day" && "active"}
							onClick={() => setDuration("7day")}
						>
							7 Day
						</span>
						<span
							type="button"
							className={duration === "30day" && "active"}
							onClick={() => setDuration("30day")}
						>
							30 Day
						</span>
						<span
							type="button"
							className={duration === "60day" && "active"}
							onClick={() => setDuration("60day")}
						>
							60 Day
						</span>
					</div>
				</div>
				<div className="mb-4">
					<button type="button" className="cmn-btn w-100">
						STAKE
					</button>
				</div>
				<div className="font-sm px-3">
					<div className="d-flex justify-content-between align-items-center mb-3">
						<span>Fee</span>
						<span>0.02 ANT</span>
					</div>
					<div className="d-flex justify-content-between align-items-center">
						<span>Transaction Fee:</span>
						<span>0.00000 HT</span>
					</div>
				</div>
			</div>
		</>
	);
};
export const WidthDrawCard = () => {
	const [duration, setDuration] = useState("30day");
	return (
		<>
			<div className="fadeIn">
				<div>
					<div className="__stake-count-badge-2">
						<span>Balance</span> <span>3000 ANT</span>
					</div>
					<div className="__stake-count-badge-2">
						<span>Stake balance:</span> <span>391 ANT</span>
					</div>
					<div className="__stake-count-badge-2">
						<span>Unlock Time</span> <span>Mar 21, 2022 15:38</span>
					</div>
				</div>
				<div className="stake-cart-area">
					<IncDecInput />
					<InputRemainders />
				</div>
				<div className="stake-duration">
					<h6 className="subtitle m-0">Duration:</h6>
					<div
						className="d-flex flex-wrap align-items-center"
						style={{ gap: "16px" }}
					>
						<span
							type="button"
							className={duration === "7day" && "active"}
							onClick={() => setDuration("7day")}
						>
							7 Day
						</span>
						<span
							type="button"
							className={duration === "30day" && "active"}
							onClick={() => setDuration("30day")}
						>
							30 Day
						</span>
						<span
							type="button"
							className={duration === "60day" && "active"}
							onClick={() => setDuration("60day")}
						>
							60 Day
						</span>
					</div>
				</div>
				<div className="mb-4">
					<button type="button" className="cmn-btn w-100">
						WITHDRAW
					</button>
				</div>
				<div className="font-sm px-3">
					<div className="d-flex justify-content-between align-items-center mb-3">
						<span>Fee</span>
						<span>0.02 ANT</span>
					</div>
					<div className="d-flex justify-content-between align-items-center">
						<span>Transaction Fee:</span>
						<span>0.00000 HT</span>
					</div>
				</div>
			</div>
		</>
	);
};
export default StakingCard;
